import { useContext, useEffect, useRef } from 'react';
import confirmCtx from 'context/confirm';

const UPDATE_EVENT = 'swupdateready';

/**
 * Asks the user whether to reload when a new service worker is ready.
 * Declining is safe: the deploy keeps previous hashed chunks on the server, so
 * the current page keeps working and the next full load picks the update up.
 */
const useServiceWorkerUpdate = () => {
	const confirm = useContext(confirmCtx);
	const promptedRef = useRef(false);

	useEffect(() => {
		const promptReload = async () => {
			if (promptedRef.current) {
				return;
			}
			promptedRef.current = true;
			const proceed = await confirm('A new version is available. Reload now?');
			if (proceed) {
				window.location.reload();
			}
		};

		// The service worker can become ready before React mounts; without this
		// check the notification would be lost.
		if (window.__swUpdateReady) {
			promptReload();
		}

		window.addEventListener(UPDATE_EVENT, promptReload);

		return () => {
			window.removeEventListener(UPDATE_EVENT, promptReload);
		};
	}, [confirm]);
};

export default useServiceWorkerUpdate;
